export const TextareaField = ({label, className, htmlFor=null, rows=3, value, onChange=null, readOnly=false}) => {

    const onChangeHandler = (event) => {
        if(onChange!==null)
            onChange(event.target.value)
    }

    return (
        <div className={className}>
            <label htmlFor={htmlFor} className="block text-sm font-medium text-gray-700">
                {label}
            </label>
            <div className="mt-1">
                <textarea
                    id={htmlFor}
                    name={htmlFor}
                    rows={rows}
                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                    value={value}
                    onChange={onChangeHandler}
                    readOnly={readOnly}
                />
            </div>
        </div>
    )
}
